/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".address-delete-modal-container[_ngcontent-%COMP%]   .address-delete-modal-footer[_ngcontent-%COMP%]{margin-top:10px;text-align:center}"];
export { styles as styles };
